// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Region_wrapper__Mv6Pw","header":"Region_header__2EOQg","circle":"Region_circle__2Fvnv"};